module.exports = __webpack_public_path__ + "img/xtts.6c80c17a.png";